import { LowerCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { CopyClipboardDirective } from '../../directives/copy-to-clipboard';

@Component({
  selector: 'app-share-menu',
  templateUrl: './share-menu.component.html',
  styleUrls: ['./share-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonMenuItemComponent, CopyClipboardDirective, LowerCasePipe],
})
export class ShareMenuComponent implements OnInit {
  private toasts = inject(ToastService);
  private check = inject(ChangeDetectorRef);
  @Input() name: string;
  @Input() title: string;
  @Input() text: string;
  @Input() link: string;
  @Input() copyInsteadOfShare: boolean;
  @Output() onClose = new EventEmitter();

  public emailHref: string;
  public facebookHref: string;
  public twitterHref: string;
  public linkedinHref: string;
  public whatsappHref: string;

  ngOnInit() {
    this.emailHref = `mailto:?subject=${encodeURIComponent(this.title)}&body=${encodeURIComponent(
      `${this.text} ${this.link}`
    )}`;
    this.facebookHref = `https://www.facebook.com/sharer/sharer.php?u=${this.link}`;
    this.twitterHref = `https://twitter.com/intent/tweet?url=${this.link}&text=${this.text || ''}`;
    this.linkedinHref = `https://www.linkedin.com/shareArticle?mini=true&url=${this.link}`;
    this.whatsappHref = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      `${this.text ? this.text + ' ' : ''}${this.link}`
    )}`;
    this.check.detectChanges();
  }

  onCopy() {
    this.toasts.add('Copied to clipboard', 'success');
  }
}
